import { ArrowLeft, ArrowRight } from 'lucide-react'
import { cn } from '../../utils/cn'

export default function SectionFooterNav({ prev, next, onPrev, onNext }) {
  return (
    <div className="w-full border-[#D9D9D9] border-t bg-[#FAFAFA] py-8">
      <div
        className={cn(
          'mx-auto flex w-full max-w-[1440px] items-center px-20',
          prev ? 'justify-between' : 'justify-end',
        )}
      >
        {prev && (
          <button
            type="button"
            onClick={onPrev}
            className="flex items-center gap-3"
          >
            <ArrowLeft size={20} className="text-[#454545]" />
            <span className="font-inter-regular text-[#AEAEAE] text-lg">
              {prev.number}
            </span>
            <span className="font-inter-extrabold text-[#454545] text-lg">
              {prev.label}
            </span>
          </button>
        )}

        {next && (
          <button
            type="button"
            onClick={onNext}
            className="flex items-center gap-3"
          >
            <span className="font-inter-regular text-[#AEAEAE] text-lg">
              {next.number}
            </span>
            <span className="font-inter-extrabold text-[#454545] text-lg">
              {next.label}
            </span>
            <ArrowRight size={20} className="text-[#454545]" />
          </button>
        )}
      </div>
    </div>
  )
}
